import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchPartnerDetail } from '@/features/partners/api'
import { partnerParamsSchema } from '@/routes/_protected/$tenantKey/settings/partners/-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/partners/$partnerId'
)({
  parseParams: (params) => parse(partnerParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, partnerId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      partner: await fetchPartnerDetail(
        {
          tenantKey,
          partnerId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.partner.name
    }
  ]
})
